import {
  BFCMPercentFormatter,
  currencyFormatter,
  noDecimalCurrencyFormatter,
  noDecimalNumberFormatter,
  numberFormatter,
  numberNoRoundingFormatter,
  percentFormatter,
  percentNoDecimalFormatter,
  percentTwoDecimalFormatter,
} from "@intelligems/ig-graphs/data-formatters";
import { DataType } from "@intelligems/ig-types";
import { useConfiguration } from "@src/api/configurations/use-configuration";

type ValueFormatterFunctionProps = {
  isAxisTick: boolean;
  value: number;
  configDataTypes: DataType[];
  _index?: number;
  decimalAmountShown?: number;
  shouldShorten?: boolean;
  maximumSignificantDigits?: number;
};

export const useGraphValueFormatter = () => {
  const storeCurrencyConfig = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");

  const returnFunc = ({
    isAxisTick,
    value,
    configDataTypes,
    _index,
    decimalAmountShown = 2,
    shouldShorten = false,
    maximumSignificantDigits,
  }: ValueFormatterFunctionProps): string | undefined => {
    const index = _index ?? 0;
    if (!storeCurrencyConfig?.value) return;

    if (configDataTypes[index] === "currency") {
      return currencyFormatter(
        value,
        isAxisTick,
        storeCurrencyConfig.value,
        !!decimalAmountShown,
        shouldShorten,
        maximumSignificantDigits
      );
    } else if (configDataTypes[index] === "percent") {
      return percentFormatter(value, isAxisTick, storeCurrencyConfig.value);
    } else if (configDataTypes[index] === "percentTwoDecimal") {
      return percentTwoDecimalFormatter(
        value,
        isAxisTick,
        storeCurrencyConfig.value,
        decimalAmountShown
      );
    } else if (configDataTypes[index] === "percentNoDecimal") {
      return percentNoDecimalFormatter(
        value,
        isAxisTick,
        storeCurrencyConfig.value
      );
    } else if (configDataTypes[index] === "numberNoDecimal") {
      return noDecimalNumberFormatter(
        value,
        isAxisTick,
        storeCurrencyConfig.value,
        maximumSignificantDigits
      );
    } else if (configDataTypes[index] === "currencyNoDecimal") {
      return noDecimalCurrencyFormatter(
        value,
        isAxisTick,
        storeCurrencyConfig.value,
        maximumSignificantDigits
      );
    } else if (configDataTypes[index] === "numberNoRounding") {
      return numberNoRoundingFormatter(
        value,
        isAxisTick,
        storeCurrencyConfig.value,
        maximumSignificantDigits
      );
    } else if (configDataTypes[index] === "bfcmPercent") {
      return BFCMPercentFormatter(value, isAxisTick, storeCurrencyConfig.value);
    } else {
      return numberFormatter(
        value,
        isAxisTick,
        storeCurrencyConfig.value,
        undefined,
        undefined,
        maximumSignificantDigits
      );
    }
  };

  return returnFunc;
};
